import React, { useState, useEffect, useRef } from 'react';
import CircularLoading from "../components/CircularLoading";
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  Modal
} from '@mui/material';
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import UsersCombo from '../components/UsersCombo';
import { api } from 'common';
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { BookingModalBody, validateBookingObj } from 'common/sharedFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  modal: {
    overflow: 'auto',
  },
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 600,
    maxHeight: 'calc(100% - 32px)',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    padding: theme.spacing(3, 4, 3),
    outline: 'none',
    [theme.breakpoints.down('md')]: {
      width: '92%',
      maxWidth: 560,
      padding: theme.spacing(2, 3, 2),
    },
    [theme.breakpoints.down('sm')]: {
      width: '96%',
      maxWidth: '100%',
      margin: theme.spacing(1),
      padding: theme.spacing(2, 2, 2),
      maxHeight: 'calc(100% - 32px)',
    },
  },
  container: {
    marginTop: theme.spacing(1),
    backgroundColor: colors.SECONDARY,
    alignContent: 'center',
    borderRadius: "8px",
    width: '70%',
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  container1: {
    backgroundColor: colors.WHITE,
    borderTopLeftRadius:"0px",
    borderTopRightRadius:"0px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    padding:'30px',
    width: '100%',
    top: "19px",
    boxShadow: "4px 4px 6px #9E9E9E",
    [theme.breakpoints.down('sm')]: {
      padding: '15px',
    },
  },
  title: {
    color: colors.WHITE,
    padding: '10px'
  },
  gridcontainer: {
    alignContent: 'center'
  },
  items: {
    margin: 0,
    width: '100%'
  },
  input: {
    fontSize: 18,
    color: "#000",
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    "& .MuiInputBase-input": {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  },
  inputdimmed: {
    fontSize: 18,
    color: colors.THIRDCOLOR,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    "& .MuiInputBase-input": {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  },
  carphoto: {
    height: '18px',
    marginRight: '10px'
  },
  carphotoRtl:{
    height: '16px',
    marginLeft:'10px'
  },
  buttonStyle: {
    margin: 0,
    width: '100%',
    height: 40,
    borderRadius: "30px",
    backgroundColor: colors.MAIN_COLOR,
    color:'#FFF'
  },
  inputRtl: {
    "& label": {
      right: 25,
      left: "auto"
    },
    "& legend": {
      textAlign: "right",
      marginRight: 18
    }
  },
  rightRty:{
    "& legend": {
      marginRight: 30
    }
  },
  commonInputStyle: {
    "& .MuiInputBase-input": {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  }
}));

const icons = {
  'paypal':require('../assets/payment-icons/paypal-logo.png'),
  'stripe':require('../assets/payment-icons/stripe-logo.png')
}

export default function AddBookings(props) {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    GetDistance,
    updateBooking,
    updateProfileWithEmail,
    checkUserExists,
    updateProfile,
    getDirectionsApi
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const cartypes = useSelector(state => state.cartypes.cars);
  const estimatedata = useSelector(state => state.estimatedata);
  const bookingdata = useSelector(state => state.bookingdata);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const providers = useSelector(state => state.paymentmethods.providers);
  const activeBookings = useSelector(state => state.bookinglistdata.active);
  const [carType, setCarType] = useState(t('select_car'));
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [userCombo, setUserCombo] = useState(null);
  const [estimateRequested, setEstimateRequested] = useState(false);
  const [bookingType, setBookingType] = useState('Book Now');
  const rootRef = useRef(null);
  const [tempRoute, setTempRoute] = useState();
  const [drivers,setDrivers] = useState([]);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const {state} = useLocation();
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [tripInstructions, setTripInstructions] = useState('');
  const [loading, setLoading] = useState(false);
  const [bookingOnWait,setBookingOnWait] = useState();
  const [selectedCategory, setSelectedCategory] = useState(t('select_category'));
  const categorylistdata = useSelector((state) => state.categorylistdata);
  const [categories, setCategories] = useState([]);
  const [hours, setHours] = useState(2);

  const instructioInitData = {
    deliveryPerson : "",
    deliveryPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    parcelTypeIndex: 0,
    optionIndex: 0,
    customFieldsIndex:0,
    parcelTypeSelected: null,
    optionSelected: null,
    customFieldsObj:null
};
const [instructionData,setInstructionData] = useState(instructioInitData);

  const [profileData,setProfileData] = useState({
    firstName : '',
    lastName : '',
    email: ''
  });

  const [payment_mode, setPaymentMode] = useState(0);
  const [radioProps,setRadioProps] =  useState([]);

  const navigate = useNavigate();

  useEffect(()=>{
      if(settings && providers){
        setSelectedProvider(providers[0]);
        let arr = [{ label: t('wallet'), value: 0, cat: 'wallet' }];
        let val = 0;
        if(!settings.disable_online && providers && providers.length > 0){
            val++;
            arr.push({ label: t('card'), value: val , cat: 'card' });
        }
        if(!settings.disable_cash){
            val++;
            arr.push({ label: t('cash'), value: val, cat: 'cash' });
        }
        setRadioProps(arr);
      }
  },[settings, providers, t]);;

  useEffect(() => {
    if (categorylistdata.categories && categorylistdata.categories.length > 1) {
      let lst = categorylistdata.categories;
      let arr = [];
      for (let i = 0; i < lst.length; i++) {
        if (lst[i].active) {
          setSelectedCategory(lst[i].category);
          break;
        }
      }
      for (let j = 0; j < lst.length; j++) {
        if (lst[j].active) {
          arr.push(lst[j]);
        }
      }
      setCategories(arr);
    }
  }, [categorylistdata.categories]);

  useEffect(() => {
    if(state && state !== null){
      let carDetails = state.carData;
      setCarType(carDetails.name)
      let instObj = {...instructionData};
      if(Array.isArray(carDetails.parcelTypes)){
        instObj.parcelTypeSelected = carDetails.parcelTypes[0];
        instObj.parcelTypeIndex = 0;
      }
      if(Array.isArray(carDetails.options)){
        instObj.optionSelected = carDetails.options[0];
        instObj.optionIndex = 0;
      }
      if(Array.isArray(carDetails.custom_fields)){
        instObj.customFieldsSelected = carDetails.custom_fields[0];
        instObj.customFieldsIndex = 0;
      }
      setInstructionData(instObj);
      setSelectedCarDetails(carDetails);
    }
  }, [instructionData, state]);

  const changeEstimate = (iData) => {
    let estimateRequest = {
      pickup: pickupAddress,
      drop: dropAddress,
      carDetails: selectedCarDetails,
      instructionData: iData,
      routeDetails: selectedCategory === 'rentals'?  {...tempRoute, time_in_secs: hours * 60 * 60} : tempRoute
    };
    dispatch(getEstimate(estimateRequest));
  }

  const [customFieldsObj, setCustomFieldsObj] = useState([]);

  const handleChange = (e) => {
    if(e.target.name === 'parcelTypeIndex'){
      let iData = { 
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails.parcelTypes[e.target.value]
      }
      setInstructionData(iData);
      changeEstimate(iData);
    }else if(e.target.name === 'optionIndex'){
      let iData = { 
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails.options[e.target.value]
      }
      setInstructionData(iData);
      changeEstimate(iData);
    }else if(e.target.name === 'payment_mode'){
      setPaymentMode(e.target.value);
    }else if(e.target.name === 'selectedProviderIndex'){
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    }else if(e.target.name === 'tripInstructions'){
      setTripInstructions(e.target.value);
    }else if(e.target.name === 'firstName'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'lastName'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'email'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else{
      setInstructionData({ ...instructionData, [e.target.name]: e.target.value });
    }
  };

  const [selectedDate, setSelectedDate] = useState(GetDateString());

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    setSelectedCarDetails(null);
    setCarType(t('select_car'));
    setBookingType('Book Now');
    setEstimateRequested(false);
  }

  useEffect(() => {
    if (auth.profile && bookingOnWait) {
      //setEstimateModalStatus(false); 
      dispatch(addBooking(bookingOnWait));
      setBookingOnWait(null);
      setLoading(false);
    }
  }, [auth.profile,bookingOnWait,dispatch,addBooking])

  useEffect(() => {
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'PAYMENT_PENDING') {
      if(bookingdata.booking.mainData.payment_mode === 'cash'){
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings')
      } else{
        if(bookingdata.booking.mainData.payment_mode === 'card'){
          setPaymentModalStatus(true);
        }else{
          setWalletModalStatus(true);
        }
      }
    }
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'NEW') {
      dispatch(clearBooking());
      setTempRoute(null);
      navigate('/bookings')
    }
  }, [bookingdata.booking,clearBooking,dispatch,navigate]);

  const handleCategorySelect = (event) => {
      setSelectedCategory(event.target.value);
      setSelectedCarDetails(null);
      setCarType(t('select_car'));
      if(event.target.value === 'bid' || event.target.value === 'delivery' || event.target.value === 'rentals'){
        setBookingType('Book Now');
      }else{
        setBookingType('Book Later');
      }
  }
  const handleCarSelect = (event) => {
    setCarType(event.target.value);
    let carDetails = null;
    for (let i = 0; i < cartypes.length; i++) {
      if (cartypes[i].name === event.target.value && cartypes[i].category === selectedCategory) {
        carDetails = cartypes[i];
        let instObj = {...instructionData};
        if(Array.isArray(cartypes[i].parcelTypes)){
          instObj.parcelTypeSelected = cartypes[i].parcelTypes[0];
          instObj.parcelTypeIndex = 0;
        }
        if(Array.isArray(cartypes[i].options)){
          instObj.optionSelected = cartypes[i].options[0];
          instObj.optionIndex = 0;
        }
        setInstructionData(instObj);
        if(cartypes[i].custom_fields && cartypes[i].custom_fields.length> 0) {
          const len = cartypes[i].custom_fields.length;
          let myObj = {};
          for(let j=0;j<len;j++){
            myObj["key" + j] = cartypes[i].custom_fields[j];
            myObj["key" + j]['value'] = "";
          }
          setCustomFieldsObj(myObj);
        }
        setSelectedCarDetails(carDetails);
      }
    }
  };

  const handleBookTypeSelect = (event) => {
    setBookingType(event.target.value);
    if (bookingType === 'Book Later') {
      setSelectedDate(GetDateString());
    }
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (estimatedata.estimate && estimateRequested) {
      setEstimateRequested(false);
      setOptionModalStatus(true);
    }
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'customer' && ((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin' || auth.profile.usertype === "subadmin")) {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden"),
            'pushToken': user.pushToken ? user.pushToken : '',
            'country': user.country_code,
            'currency': user.currency_code,
            'fleetadminrider': user.fleetadmin
          });
        }
      }
      setUsers(arr);
      let arrDrivers = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if ((user.usertype) && (user.usertype === 'driver') && (user.approved === true) && (user.queue === false) && (user.location)) {
          if((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin' || auth.profile.usertype === "subadmin" || auth.profile.usertype === 'customer'){
            arrDrivers.push({
              'uid': user.id,
              'location': user.location,
              'carType': user.carType,
              'fleetadmin': user.fleetadmin ? user.fleetadmin : null,
              'category': user.category,
              'activeCar_position': user.activeCar_position
            });
          }
        }
      }
      setDrivers(arrDrivers);
    }
  }, [estimatedata.estimate, userdata.users, estimateRequested, settings.AllowCriticalEditsAdmin, auth.profile.usertype, auth.profile.uid]);
 
 
  useEffect(() => {
    if(auth.profile.usertype && auth.profile.usertype==='customer'){
      setUserCombo({
        'firstName': auth.profile.firstName,
        'lastName': auth.profile.lastName,
        'mobile': auth.profile.mobile,
        'email': auth.profile.email,
        'uid': auth.profile.uid,
        'pushToken': auth.profile.pushToken ? auth.profile.pushToken : '',
        'currency': auth.profile.currency_code,
        'country': auth.profile.country_code,
        'fleetadminrider': auth.profile.fleetadmin ? auth.profile.fleetadmin : null
      })
    }
  }, [auth.profile]);


  const mobile = (userCombo && userCombo.mobile ? true : false);

  const handleGetOptions = async (e) => {
    e.preventDefault();
    if((settings && settings.imageIdApproval && auth.profile.usertype ==='customer' && auth.profile.verifyId) || auth.profile.usertype==='admin' || auth.profile.usertype === "subadmin" || (settings && !settings.imageIdApproval && auth.profile.usertype ==='customer') || auth.profile.usertype === 'fleetadmin'){
      if(!(settings && settings.disable_cash && (auth.profile.usertype==='admin'|| auth.profile.usertype === "subadmin" || auth.profile.usertype === 'fleetadmin')) || auth.profile.usertype==='customer'){
        if((auth.profile.usertype==='customer' && parseFloat(auth.profile.walletBalance)>=0) || ((auth.profile.usertype==='admin' || auth.profile.usertype === "subadmin" || auth.profile.usertype === 'fleetadmin') && (userCombo?.firstName &&userCombo.firstName?.length > 0 && userCombo?.lastName && userCombo.lastName?.length > 0 && userCombo.email && userCombo.email?.length > 0 ))){
          setEstimateRequested(true);
          if (userCombo && pickupAddress && dropAddress && selectedCarDetails) { 
            // const directionService = new window.google.maps.DirectionsService();
            // directionService.route(
            //   {
            //     origin: new window.google.maps.LatLng(pickupAddress.coords.lat, pickupAddress.coords.lng),
            //     destination: new window.google.maps.LatLng(dropAddress.coords.lat, dropAddress.coords.lng),
            //     travelMode: window.google.maps.TravelMode.DRIVING
            //   },
            //   (result, status) => {
            //     if (status === window.google.maps.DirectionsStatus.OK) {
            //       const route = {
            //         distance_in_km:(result.routes[0].legs[0].distance.value / 1000),
            //         time_in_secs:result.routes[0].legs[0].duration.value,
            //         polylinePoints:result.routes[0].overview_polyline
            //       };
            const route = await getDirectionsApi(pickupAddress.coords.lat + "," + pickupAddress.coords.lng, dropAddress.coords.lat + ',' + dropAddress.coords.lng, null);
                  setTempRoute(route);
                  if(pickupAddress && dropAddress){
                    if (bookingType === 'Book Now') {
                      if(mobile === true){
                          let estimateRequest = {
                            pickup: pickupAddress,
                            drop: dropAddress,
                            carDetails: selectedCarDetails,
                            instructionData: instructionData,
                            routeDetails: selectedCategory === 'rentals'?  {...route, time_in_secs: hours * 60 * 60} : route
                          };
                          dispatch(getEstimate(estimateRequest));
                      }else{
                        setCommonAlert({ open: true, msg: t('incomplete_user')});
                      }
                    } else {
                        if (bookingType === 'Book Later' && selectedDate) {
                          if (MinutesPassed(selectedDate) >= 15) {
                            if(mobile === true){
                                let estimateRequest = {
                                  pickup: pickupAddress,
                                  drop: dropAddress,
                                  carDetails: selectedCarDetails,
                                  instructionData: instructionData,
                                  routeDetails: selectedCategory === 'rentals'?  {...route, time_in_secs: hours * 60 * 60} : route
                                };
                                dispatch(getEstimate(estimateRequest));
                            }else{
                              setCommonAlert({ open: true, msg: t('incomplete_user')});
                            }
                          } else {
                            setCommonAlert({ open: true, msg: t('past_booking_error') });
                          }
                        } else {
                          setCommonAlert({ open: true, msg: t('select_proper') });
                        }
                      }
                  } else {
                    setCommonAlert({ open: true, msg: t('place_to_coords_error') })
                  }
          } else {
            setCommonAlert({ open: true, msg: t('select_proper') })
          }
        }else{
          if(auth.profile.usertype==='admin' || auth.profile.usertype === "subadmin" || auth.profile.usertype === 'fleetadmin'){
            setCommonAlert({ open: true, msg: t('selectUserDetailMissing') })
          }else{
            setCommonAlert({ open: true, msg: t('wallet_balance_low') })
          }
        }
      } else {
        setCommonAlert({ open: true, msg: t('cash_booking_false') })
      }
    } else {
      setCommonAlert({ open: true, msg: t('verifyid_error') })
    }    
  }

  const handleWalletPayment = (e) => {
    e.preventDefault();
    let curBooking = { ...bookingdata.booking.mainData };
    if(parseFloat(curBooking.trip_cost)>parseFloat(auth.profile.walletBalance) && radioProps[payment_mode].cat === 'wallet'){
      setCommonAlert({open:true, msg: t('wallet_balance_low')});
    }else{
      let requestedDrivers = {};
      if ((settings.autoDispatch && bookingType === 'Book Now') || (selectedCategory === 'freight' || selectedCategory === 'intercity')){
        for (let i = 0; i < drivers.length; i++) {
          const driver = drivers[i];
          let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
          if (settings.convert_to_mile) {
            distance = distance / 1.609344;
          }
          if (distance < (settings && ((selectedCategory === 'freight' && settings.freightDriverRadius > 0 ? settings.freightDriverRadius : (selectedCategory === 'intercity' && settings.intercityDriverRadius > 0 ? settings.intercityDriverRadius : (settings.driverRadius ? settings.driverRadius : 10))))) && 
            (((selectedCategory === 'delivery' || selectedCategory === 'bid' || selectedCategory === 'freight' || selectedCategory === 'intercity') && (selectedCategory === driver.category || !settings.carType_required) && ((auth.profile.usertype === 'fleetadmin' && driver.fleetadmin === auth.profile.uid) || auth.profile.usertype !== 'fleetadmin')) ||

            (((selectedCategory === 'rentals' && settings.carType_required && selectedCarDetails.name === driver.carType && selectedCategory === driver.category) || !settings.carType_required) && ((auth.profile.usertype === 'fleetadmin' && driver.fleetadmin === auth.profile.uid) || auth.profile.usertype !== 'fleetadmin')))) {

             if((selectedCategory === 'delivery' || selectedCategory === 'bid' || selectedCategory === 'freight' || selectedCategory === 'intercity') && (settings.booking_high_to_low ? driver.activeCar_position >= selectedCarDetails.capacity : selectedCarDetails.name === driver.carType)){
                requestedDrivers[driver['uid']] = true;
              } 
              else if(selectedCategory === 'rentals'){
                requestedDrivers[driver['uid']] = true;
              }
            }
        }
      }
      curBooking.prepaid = true;
      curBooking.status = 'NEW';
      curBooking.payment_mode = "wallet";
      curBooking.customer_paid = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.requestedDrivers = requestedDrivers;

      dispatch(updateBooking(curBooking));

      setTimeout(()=>{
        dispatch(clearEstimate());
        setPaymentModalStatus(false);
        setWalletModalStatus(false);
        clearForm();
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings')
      },1500);
    }
  }


  const confirmBooking = (e) => {
    e.preventDefault();
    let requestedDrivers = {};
    let driverEstimates = {};

    let notfound = true;
    if(activeBookings){
        for(let i=0; i<activeBookings.length; i++){
            if(activeBookings[i].payment_mode==='wallet' && activeBookings[i].status!=='PAID'){
                notfound = false;
                break;
            }
        }
    }

    if((radioProps[payment_mode].cat === 'wallet' && notfound && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || auth.profile.usertype === 'admin' || auth.profile.usertype === "subadmin" || auth.profile.usertype === 'fleetadmin'){
      if ((radioProps[payment_mode].cat === 'wallet' && (parseFloat(auth.profile.walletBalance) >= parseFloat(estimatedata.estimate.estimateFare)) &&  (selectedCategory === 'delivery' || selectedCategory === 'freight')  && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || (radioProps[payment_mode].cat === 'wallet' && auth.profile.usertype === 'customer')|| auth.profile.usertype === 'admin' || auth.profile.usertype === "subadmin" || auth.profile.usertype === 'fleetadmin') {
        if (settings.autoDispatch && ((selectedCategory === 'bid' && bookingType === 'Book Now') || selectedCategory !== 'bid')){
          for (let i = 0; i < drivers.length; i++) {
            const driver = drivers[i];
            let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
            if (settings.convert_to_mile) {
              distance = distance / 1.609344;
            }

            if (distance < (settings && ((selectedCategory === 'freight' && settings.freightDriverRadius > 0 ? settings.freightDriverRadius : (selectedCategory === 'intercity' && settings.intercityDriverRadius > 0 ? settings.intercityDriverRadius : (settings.driverRadius ? settings.driverRadius : 10))))) && 
            (((selectedCategory === 'delivery' || selectedCategory === 'bid' || selectedCategory === 'freight' || selectedCategory === 'intercity') && (selectedCategory === driver.category || !settings.carType_required) && ((auth.profile.usertype === 'fleetadmin' && driver.fleetadmin === auth.profile.uid) || auth.profile.usertype !== 'fleetadmin')) ||

            (((selectedCategory === 'rentals' && settings.carType_required && selectedCarDetails.name === driver.carType && selectedCategory === driver.category) || !settings.carType_required) && ((auth.profile.usertype === 'fleetadmin' && driver.fleetadmin === auth.profile.uid) || auth.profile.usertype !== 'fleetadmin')))) {

             if((selectedCategory === 'delivery' || selectedCategory === 'bid' || selectedCategory === 'freight' || selectedCategory === 'intercity') && (settings.booking_high_to_low ? driver.activeCar_position >= selectedCarDetails.capacity : selectedCarDetails.name === driver.carType)){
                requestedDrivers[driver['uid']] = true;
                driverEstimates[driver['uid']] = {distance: distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min'};
              } 
              else if(selectedCategory === 'rentals'){
                requestedDrivers[driver['uid']] = true;
                driverEstimates[driver['uid']] = {distance: distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min'};
              }
            }
          }
          if(Object.keys(requestedDrivers).length=== 0){
            setCommonAlert({open:true, msg: t('no_driver_found_alert_messege')});
            return;
          }
        }
        
        let values = Object.values(customFieldsObj);
        let foundIssue = false;

        for(let i=0;i< values.length; i++){
          if((values[i].field_type === 'text' || values[i].field_type === 'numeric') &&  values[i].value === "" ){
            foundIssue = true;
            break;
            
          }
        }

        if(foundIssue && values.length > 0){
          setCommonAlert({open:true, msg:t('deliveryDetailMissing')});
          return;
        }



        let bookingObject = {
          pickup: pickupAddress,
          drop: dropAddress,
          carDetails: selectedCarDetails,
          userDetails: {
            uid: userCombo.uid,
            firstName: userCombo.firstName,
            lastName: userCombo.lastName,
            mobile: userCombo.mobile,
            pushToken: userCombo.pushToken,
            email: userCombo.email,
            country_code: userCombo.country,
            currency_code: userCombo.currency
          },
          estimate: estimatedata.estimate,
          instructionData: instructionData,
          customFieldsObj: customFieldsObj,
          tripInstructions: tripInstructions,
          tripdate: bookingType === 'Book Later' ? new Date(selectedDate).getTime() : new Date().getTime(),
          bookLater: bookingType === 'Book Later' ? true : false,
          settings: settings,
          booking_type_admin: auth.profile.usertype === 'admin'? true: false,
          fleetadmin: auth.profile.usertype === 'fleetadmin'? auth.profile.uid: null,
          fleetadminrider: userCombo.fleetadminrider ? userCombo.fleetadminrider : null,
          requestedDrivers:selectedCarDetails.hasBid ? requestedDrivers : radioProps[payment_mode].cat === 'cash' ? requestedDrivers : (auth.profile.usertype === 'admin'|| auth.profile.usertype === "subadmin" ) ? requestedDrivers : null,
          driverEstimates: driverEstimates,
          payment_mode: (auth.profile.usertype === 'admin' || auth.profile.usertype === "subadmin" || auth.profile.usertype === 'fleetadmin' )?'cash':radioProps[payment_mode].cat,
          booking_from_web: true,
          hasBid: selectedCarDetails.hasBid
        };
        if(auth.profile.usertype === 'customer' && !(auth.profile.firstName && auth.profile.lastName && auth.profile.email && auth.profile.firstName.length>0 && auth.profile.lastName.length>0 && auth.profile.email.length>0)){
          const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
          if (((selectedCategory !== 'bid' &&  selectedCategory !== 'intercity' && selectedCategory !== 'rentals') && /\S/.test(instructionData.deliveryPerson) && regx1.test(instructionData.deliveryPersonPhone) && instructionData.deliveryPersonPhone && instructionData.deliveryPersonPhone.length > 6)){
            if((profileData.firstName && profileData.firstName.length > 0 && profileData.lastName && profileData.lastName.length > 0) || (auth.profile.firstName && auth.profile.firstName.length > 0 && auth.profile.lastName && auth.profile.lastName.length > 0)){
              const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              if((re.test(profileData.email) && !auth.profile.email) || (auth.profile.email && auth.profile.email.length > 0)){
                setLoading(true);
                checkUserExists({email: profileData.email}).then(async(res) => {
                  if (res.users && res.users.length > 0) {
                    setLoading(false);
                    alert(t('user_exists'));
                  }
                  else{
                    setLoading(false);
                    if(radioProps[payment_mode].cat === 'card'){
                      const paymentPacket = { 
                        payment_mode: 'card',
                        customer_paid: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                        cardPaymentAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                        discount: 0,
                        usedWalletMoney:0,
                        cashPaymentAmount: 0,
                        promo_applied: false,
                        promo_details: null,
                        payableAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                      };
                      bookingObject['paymentPacket'] = paymentPacket;
                    }
            
                    const result = validateBookingObj(t, bookingObject, instructionData, selectedCarDetails);
                    if(result.error){
                      setCommonAlert({ open: true, msg: result.msg });
                    } else{
                      profileData['uid'] = auth.profile.uid;
                      let bookingData = result.bookingObject;
                      bookingData.userDetails.firstName = profileData.firstName;
                      bookingData.userDetails.lastName = profileData.lastName;
                      bookingData.userDetails.email = profileData.email;
                      setBookingOnWait(bookingData);
                    }
                    if(auth.profile.email && auth.profile.email.length > 0){
                      let userData = {
                        firstName: profileData.firstName,
                        lastName: profileData.lastName,
                      }
                      dispatch(updateProfile(userData)); 
                    }else{
                      setTimeout(()=>{
                        dispatch(updateProfileWithEmail(profileData));
                      },200)
                    }
                  }
              });
              } else {
                setCommonAlert({ open: true, msg: t('proper_email') })
              }
            } else {
              setCommonAlert({ open: true, msg: t('proper_input_name') })
            }
          } else {
            setCommonAlert({ open: true, msg: t('deliveryDetailMissing') })
          }
        } else{
          if(radioProps[payment_mode].cat === 'card'){
            const paymentPacket = { 
              payment_mode: 'card',
              customer_paid: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
              cardPaymentAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
              discount: 0,
              usedWalletMoney:0,
              cashPaymentAmount: 0,
              promo_applied: false,
              promo_details: null,
              payableAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
            };
            bookingObject['paymentPacket'] = paymentPacket;
          }
          const result = validateBookingObj(t, bookingObject, instructionData, selectedCarDetails);
          if(result.error){
            setCommonAlert({ open: true, msg: result.msg });
          } else{
            setOptionModalStatus(false);
            dispatch(addBooking(result.bookingObject));
          }
        }
      }else{
        setCommonAlert({ open: true, msg: t('wallet_balance_low') });
      } 
    } else {
      setCommonAlert({ open: true, msg: t('wallet_booking_alert') });
    }
  };

  const handleOptionModalClose = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
    dispatch(clearEstimate());
    setInstructionData(instructioInitData);
  };


  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleWalletModalClose = (e) => {
    setTimeout(()=>{
      setWalletModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    },1500);
  }

  const handlePaymentModalClose = (e) => {
    setTimeout(()=>{
      setPaymentModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    },1500);
  }

  const handlePayNow = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    
    if(selectedProvider.id === 'stripe'){
        setLoading(true);
        setPaymentModalStatus(false);
        try{
            const res = await fetch(selectedProvider.link, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({...data, isPWA: true})
            });
            const result = await res.json();
            if(result.url){
                window.location.href = result.url;
            } else {
                const msg = (result.error && result.error.message) ? result.error.message : (result.error && result.error.raw && result.error.raw.message) ? result.error.raw.message : (typeof result.error === 'string' ? result.error : t('payment_failed'));
                setCommonAlert({ open: true, msg: msg });
                setLoading(false);
            }
        }catch(err){
            setCommonAlert({ open: true, msg: t('payment_failed')});
            setLoading(false);
        }
    } else {
        e.target.submit();
    }
  }

  const handleHoursChange = (event, newValue) => {
    if (typeof newValue === 'number') {
      setHours(newValue);
      let estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails:{...tempRoute, time_in_secs: newValue * 60 * 60}
      };
      dispatch(getEstimate(estimateRequest));
    }
  };
  
  const handleIHoursAdd = () => {
    if(hours < 18){
      setHours(hours+1);
      let estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails:{...tempRoute, time_in_secs: (hours+1) * 60 * 60}
      };
      dispatch(getEstimate(estimateRequest));
    }
  };
  const handleIHoursSubtruct = () => {
    if(hours > 1){
      setHours(hours-1);
      let estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails:{...tempRoute, time_in_secs: (hours-1) * 60 * 60}
      };
      dispatch(getEstimate(estimateRequest));
    }
  };
  const ShowDetails = (cat)=>{
    if(cat==='wallet') return t("this_is_wallet")
    if(cat==='card') return t("this_is_stripe")
    if (cat==='cash') return  t("this_is_Cash")
  }
  
  return (
    loading? <CircularLoading/>:
    <div className={classes.container} ref={rootRef}>
      <Grid item xs={12} sm={12} md={8} lg={8}>
        <Grid item xs={12}>
            <Typography component="h1" variant="h5" className={classes.title} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
              {t('addbookinglable')}
            </Typography>
          </Grid>
        <div className={classes.container1}>
          <Grid container spacing={2} >
            <Grid item xs={12} >
              {users && auth.profile.usertype && auth.profile.usertype!=='customer' ?
                <UsersCombo
                  className={classes.items}
                  placeholder={t('select_user')}
                  users={users}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
                : null}
            </Grid>
            <Grid item xs={12} >
              <GoogleMapsAutoComplete
                variant={"outlined"}
                placeholder={t('pickup_location')}
                value={pickupAddress}
                className={classes.items}
                onChange={
                  (value) => {
                    setPickupAddress(value);
                  }
                }
              />
            </Grid>
            <Grid item xs={12} >
              <GoogleMapsAutoComplete placeholder={t('drop_location')}
                variant={"outlined"}
                value={dropAddress}
                className={classes.items}
                onChange={
                  (value) => {
                    setDropAddress(value);
                  }
                }
              />
            </Grid>

            <Grid item xs={12} sm={4} >
              {cartypes && categories ?
                  <Select
                     labelId="demo-simple-select-label"
                     id="demo-simple-select"
                      value={selectedCategory}
                      onChange={handleCategorySelect}
                      variant="outlined"
                      fullWidth
                      style={{textAlign:isRTL==='rtl'? 'right':'left',}}
                      className={carType === t('select_category') ? classes.inputdimmed : classes.input}
                     
                  >
                    <MenuItem dense={true} value={t('select_category')} key={t('select_category')} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
                      {t('select_category')}
                    </MenuItem>
                    {
                      categories.map((item) =>
                        <MenuItem dense={true} key={item.category} value={item.category} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
                          <img src={item.cat_image} className={isRTL==='rtl'? classes.carphotoRtl : classes.carphoto} alt="car types"/>{t(item.category)}
                        </MenuItem>
                      )
                    }
                  </Select>
                : null}
            </Grid>
            <Grid item xs={12} sm={5} >
              {cartypes && cartypes.filter(carT => carT.category === selectedCategory && carT.active === true) ?
                  <Select
                     labelId="demo-simple-select-label"
                     id="demo-simple-select"
                      value={carType}
                      onChange={handleCarSelect}
                      variant="outlined"
                      fullWidth
                      style={{textAlign:isRTL==='rtl'? 'right':'left',}}
                      className={carType === t('select_car') ? classes.inputdimmed : classes.input}
                     
                  >
                    <MenuItem dense={true} value={t('select_car')} key={t('select_car')} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
                      {t('select_car')}
                    </MenuItem>
                    {
                      cartypes.filter(carT => carT.category === selectedCategory && carT.active === true).sort((a, b) => a.pos - b.pos).map((car) =>
                        <MenuItem dense={true}  key={car.name} value={car.name} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
                          <img src={car.image} className={isRTL==='rtl'? classes.carphotoRtl : classes.carphoto} alt="car types"/>{car.name}
                        </MenuItem>
                      )
                    }
                  </Select>
                : null}
            </Grid>
            <Grid item xs={12} sm={3}>
                <Select
                  id="booking-type-native"
                  value={bookingType}
                  onChange={handleBookTypeSelect}
                  className={classes.input}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  variant="outlined"
                  fullWidth
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {(selectedCategory === 'bid' || selectedCategory === 'delivery' || selectedCategory === 'rentals') ?
                  <MenuItem dense key={"Book Now"} value={"Book Now"} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
                    {t('book_now')}
                  </MenuItem>
                  :null}
                  <MenuItem dense key={"Book Later"} value={"Book Later"} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
                    {t('book_later')}
                  </MenuItem>
                </Select>
              </Grid>
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={8} md={6} >
                  <TextField
                    id="datetime-local"
                    label={t('booking_date_time')}
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    className={isRTL==='rtl'?classes.inputRtl:classes.commonInputStyle}
                    InputProps={{
                      className: classes.input,
                      style:{textAlignLast:isRTL==='rtl'?'end':'start'}
                    }}
                    inputProps={{ min: new Date().toISOString().slice(0, 16),}}
                    value={selectedDate}
                    onChange={onDateChange}
                  />
                </Grid>
              : null}
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={4} md={6} >
                  <Button
                    size="lg"
                    onClick={handleGetOptions}
                    variant="contained" 
                    color="success"
                    className={classes.buttonStyle}
                  >
                    <i className="fas fa-car" style={isRTL ==='rtl' ? {marginLeft:5}:{marginRight:5}}/>
                    {t('book')}
                  </Button>
                </Grid>
              :
                <Grid item xs={12} >
                  <Button
                    size="lg"
                    onClick={handleGetOptions}
                    variant="contained" 
                    color="success"
                    className={classes.buttonStyle}
                  >
                    <i className="fas fa-car" style={isRTL ==='rtl' ? {marginLeft:5}:{marginRight:5}}/>
                    {t('book')}
                  </Button>
                </Grid>
              }
          </Grid>
        </div>
      </Grid>
      <Modal
        disableEnforceFocus
        disableAutoFocus
        open={optionModalStatus}
        onClose={handleOptionModalClose}
      >
        <div className={classes.paper}>
          <Grid container spacing={2}>
            <BookingModalBody 
            classes={classes}  
            instructionData={instructionData} 
            handleChange={handleChange}
            tripInstructions={tripInstructions}
            customFieldsObj={customFieldsObj}
            setCustomFieldsObj={setCustomFieldsObj}
            auth={auth}
            profileData={profileData}
            selectedCarDetails={selectedCarDetails}
            hours={hours}
            handleHoursChange={handleHoursChange}
            handleIHoursAdd={handleIHoursAdd}
            handleIHoursSubtruct={handleIHoursSubtruct}
          />
          {selectedCarDetails && selectedCarDetails.hasBid ? null :
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
              {auth.profile.swipe_symbol===false?
                <Typography color={'primary'} style={{fontSize:30}}>
                  {t('total')} - {auth ? auth.profile.symbol:null} {estimatedata.estimate ? estimatedata.estimate.estimateFare : null}
                </Typography>
                :
                <Typography color={'primary'} style={{fontSize:30}}>
                  {t('total')} - {estimatedata.estimate ? estimatedata.estimate.estimateFare : null} {auth ? auth.profile.symbol:null}
                </Typography>
              }
            </Grid>
          }

          {auth.profile.usertype === 'customer'?
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
              <FormControl component="fieldset">
                <FormLabel component="legend">{t('payment_mode')}</FormLabel>
                <RadioGroup row name="payment_mode" value={payment_mode} onChange={handleChange}>
                  {radioProps.map((element,index) =>
                    <Button
                    key={index} 
                    variant='outlined' 
                    style={{border: `solid 2px ${colors.SECONDARY}`, 
                    backgroundColor:element.value===payment_mode?colors.SECONDARY:colors.WHITE, 
                    color:colors.BLACK,display:'flex', gap:"15px", width:"150px"}} 
                    onClick={()=>setPaymentMode(element.value)}  >
                      {element.cat==="card" ? t("stripe") :element.label}
                      {element.value===payment_mode?
                      <Tooltip  >
                          <InfoOutlinedIcon onClick={()=> setCommonAlert({ open: true, isTitle:true, msg: ShowDetails(element.cat)})} />
                      </Tooltip>
                      :null}
                    </Button>
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>
          :null}
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {loading?
            <DialogActions style={{justifyContent:'center', alignContent:'center'}}>
              <CircularProgress/>
            </DialogActions>
          :
            <Grid item xs={12} >
              <Button onClick={handleOptionModalClose} variant="contained" color="primary">
                {t('cancel')}
              </Button>
              <Button onClick={confirmBooking} variant="contained" color="primary" style={isRTL==='rtl'?{marginRight:10}:{marginLeft:10}}>
                {t('book_now')}
              </Button>
            </Grid>
          }
          </Grid>
          </Grid>
        </div>
      </Modal>
      <Modal
        disableEnforceFocus
        disableAutoFocus
        open={walletModalStatus}
        onClose={handleWalletModalClose}
      >
        <div className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
            <Typography  style={{fontWeight:'bolder', marginBottom:10}}>
              {t('payment')}
            </Typography>
            {bookingdata && bookingdata.booking?
            <Typography color={"primary"} style={{fontSize:30}}>
              { (auth.profile.swipe_symbol===false? auth.profile.symbol + bookingdata.booking.mainData.trip_cost :  bookingdata.booking.mainData.trip_cost + auth.profile.symbol) }
            </Typography>
            :null}
            <Typography >
              {t('use_wallet_balance') + " " + (auth.profile.swipe_symbol===false? auth.profile.symbol + parseFloat(auth.profile.walletBalance).toFixed(2) :  parseFloat(auth.profile.walletBalance).toFixed(2) + auth.profile.symbol) + ")"}
            </Typography>
          </Grid>            
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handleWalletModalClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" style={{marginLeft:10}} onClick={handleWalletPayment}>
              {t('paynow_button')}
            </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>
      <Modal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
      >
        <div className={classes.paper}>
          <Grid container spacing={2}>
            {providers && selectedProvider && bookingdata && bookingdata.booking?
          <form action={selectedProvider.link} method="POST" onSubmit={handlePayNow}>
            <input type='hidden' name='order_id' value={bookingdata.booking.booking_id}/>
            <input type='hidden' name='amount' value={bookingdata.booking.mainData.trip_cost}/>
            <input type='hidden' name='currency' value={auth.profile.currency_code}/>
            <input type='hidden' name='product_name' value={t('bookingPayment')}/>
            <input type='hidden' name='first_name' value={auth.profile.firstName}/>
            <input type='hidden' name='last_name' value={auth.profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={bookingdata.booking.mainData.customer}/>
            <input type='hidden' name='mobile_no' value={bookingdata.booking.mainData.customer_contact}/>
            <input type='hidden' name='email' value={bookingdata.booking.mainData.customer_email}/>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
              <FormControl fullWidth>
              <FormLabel component="legend">{t('payment')}</FormLabel>
              <Select
                  id="selectedProviderIndex"
                  name= "selectedProviderIndex"
                  value={selectedProviderIndex}
                  label={t('payment')}
                  onChange={handleChange}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {providers.map((provider,index) =>
                    <MenuItem key={provider.id} value={index}><img style={{height:24,margin:7}} src={icons[provider.id]} alt={provider.id}/> </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handlePaymentModalClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" type="submit" style={{marginLeft:10}} onClick={handlePaymentModalClose}>
              {t('paynow_button')}
            </Button>
            </Grid>
          </form>
          :null}
          </Grid>
        </div>
      </Modal>
      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={estimatedata.error.flag} onClose={handleEstimateErrorClose}>{estimatedata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} isTitle={commonAlert.isTitle} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}
